/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { HashUtil, HashUtilInterface } from "../HashUtil";

const _abi = [
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "orderHash",
        type: "bytes32",
      },
      {
        components: [
          {
            internalType: "uint8",
            name: "v",
            type: "uint8",
          },
          {
            internalType: "bytes32",
            name: "r",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "s",
            type: "bytes32",
          },
        ],
        internalType: "struct OrderLib.Signature",
        name: "sig",
        type: "tuple",
      },
    ],
    name: "getAddressFromOrderHash",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "size",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "isBuy",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "nonce",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "price",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "offerExpire",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "fee",
            type: "uint256",
          },
        ],
        internalType: "struct OrderLib.SmallOrder",
        name: "order",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "address",
            name: "baseAsset",
            type: "address",
          },
          {
            internalType: "address",
            name: "quoteAsset",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "expiry",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "strike",
            type: "uint256",
          },
          {
            internalType: "uint8",
            name: "optionType",
            type: "uint8",
          },
        ],
        internalType: "struct OrderLib.OrderCommon",
        name: "common",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint8",
            name: "v",
            type: "uint8",
          },
          {
            internalType: "bytes32",
            name: "r",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "s",
            type: "bytes32",
          },
        ],
        internalType: "struct OrderLib.Signature",
        name: "sig",
        type: "tuple",
      },
    ],
    name: "getAddressFromSignedOrder",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "size",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "isBuy",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "nonce",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "price",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "offerExpire",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "fee",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "baseAsset",
            type: "address",
          },
          {
            internalType: "address",
            name: "quoteAsset",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "expiry",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "strike",
            type: "uint256",
          },
          {
            internalType: "uint8",
            name: "optionType",
            type: "uint8",
          },
        ],
        internalType: "struct OrderLib.Order",
        name: "order",
        type: "tuple",
      },
    ],
    name: "hashOrder",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "baseAsset",
            type: "address",
          },
          {
            internalType: "address",
            name: "quoteAsset",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "expiry",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "strike",
            type: "uint256",
          },
          {
            internalType: "uint8",
            name: "optionType",
            type: "uint8",
          },
        ],
        internalType: "struct OrderLib.OrderCommon",
        name: "common",
        type: "tuple",
      },
    ],
    name: "hashOrderCommon",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "size",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "isBuy",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "nonce",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "price",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "offerExpire",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "fee",
            type: "uint256",
          },
        ],
        internalType: "struct OrderLib.SmallOrder",
        name: "order",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "address",
            name: "baseAsset",
            type: "address",
          },
          {
            internalType: "address",
            name: "quoteAsset",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "expiry",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "strike",
            type: "uint256",
          },
          {
            internalType: "uint8",
            name: "optionType",
            type: "uint8",
          },
        ],
        internalType: "struct OrderLib.OrderCommon",
        name: "common",
        type: "tuple",
      },
    ],
    name: "hashSmallOrder",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "hash",
        type: "bytes32",
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32",
      },
    ],
    name: "validateSignature",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
];

const _bytecode =
  "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";

type HashUtilConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: HashUtilConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class HashUtil__factory extends ContractFactory {
  constructor(...args: HashUtilConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<HashUtil> {
    return super.deploy(overrides || {}) as Promise<HashUtil>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): HashUtil {
    return super.attach(address) as HashUtil;
  }
  connect(signer: Signer): HashUtil__factory {
    return super.connect(signer) as HashUtil__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): HashUtilInterface {
    return new utils.Interface(_abi) as HashUtilInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): HashUtil {
    return new Contract(address, _abi, signerOrProvider) as HashUtil;
  }
}
